<template>
  <div class="col-md-6">
    <div
      class="panel panel-default"
      style="
        border-left: solid 1px #ddd;
        border-right: solid 1px #ddd;
        border-top: solid 1px #ddd;
        border-bottom: solid 1px #ddd;
      "
    >
      <div class="panel-heading" style="border-bottom: solid 1px #ddd">
        <h5><strong>Complete Order</strong></h5>
      </div>
      <div id="payment_card" class="row">
        <div class="panel" style="margin: 10px">
          <div v-if="!canCheckout" class="alert alert-danger">
            Orders may only be placed by customer level accounts.
          </div>
          <div v-else class="col-md-12">
            <div class="tab-content">
              <div
                id="tab_payment_methods"
                class="tab-pane checkout-pmnt-methods"
                style="display: grid; grid-gap: 2rem"
              >
                <div class="text-center">
                  <button
                    type="button"
                    class="btn btn-primary btn-block"
                    onClick="hideTabsCheckout('credit_card');"
                  >
                    <i
                      class="fa fa-credit-card white-color"
                      style="font-size: 5rem; padding: 1rem 1rem 0.5rem"
                    >
                    </i>
                    <br />
                    <div style="padding-bottom: 0.5rem">Credit Card</div>
                  </button>
                </div>

                <div v-if="hasBank" class="text-center">
                  <button
                    type="button"
                    class="btn btn-primary btn-block"
                    onClick="hideTabsCheckout('bank_acct');"
                  >
                    <i
                      class="fa fa-university white-color"
                      style="font-size: 5rem; padding: 1rem 1rem 0.5rem"
                    >
                    </i>
                    <br />
                    <div style="padding-bottom: 0.5rem">Bank Account</div>
                  </button>
                </div>

                <div v-if="hasWallet" class="text-center">
                  <button
                    type="button"
                    class="btn btn-primary btn-block"
                    onClick="hideTabsCheckout('wallet');"
                  >
                    <i
                      class="fa fa-cloud white-color"
                      style="font-size: 5rem; padding: 1rem 1rem 0.5rem"
                    >
                    </i>
                    <br />
                    <div style="padding-bottom: 0.5rem">Cloud Wallet</div>
                  </button>
                </div>
              </div>

              <div
                id="tab_credit_card"
                role="tabpanel"
                class="tab-pane"
                style="padding: 2rem; padding-bottom: 3rem"
              >
                <div
                  class="payment_instrument_logos text-center sep-bottom-xs col-sm-12"
                >
                  <img alt="Visa" class="" src="/build/img/visa.png" />
                  <img
                    alt="MasterCard"
                    class=""
                    src="/build/img/mastercard.png"
                  />
                  <img alt="Discover" class="" src="/build/img/discover.png" />
                  <img
                    alt="American Express"
                    class=""
                    src="/build/img/american_express.png"
                  />
                  <img
                    alt="JCB"
                    class=""
                    src="/build/img/jcb.png"
                    style="margin-right: 0"
                  />
                </div>
                <div class="sep-bottom-xs text-center">
                  <button
                    type="button"
                    class="btn btn-default btn-sm mt-2 checkout-btn"
                    data-toggle="modal"
                    data-target="#new_credit_card_modal"
                    :disabled="newAddressPending"
                  >
                    New Credit Card
                  </button>
                </div>
                <div v-if="internalCreditCards" class="text-left form-group">
                  <label for="credit_card">Credit Card</label>
                  <select
                    id="credit_card"
                    v-model="selectedCreditCardId"
                    name="credit_card"
                    class="form-control"
                  >
                    <option
                      v-for="(creditCard, index) in internalCreditCards"
                      :key="index"
                      :value="creditCard.id"
                      :disabled="creditCard.expired"
                    >
                      {{
                        creditCard.nickname ? `${creditCard.nickname} - ` : ""
                      }}
                      {{
                        `${creditCard.card_type} - ${creditCard.masked_number}`
                      }}
                    </option>
                  </select>
                </div>
                <div
                  style="
                    display: grid;
                    grid-template-columns: auto auto;
                    justify-content: space-between;
                    align-items: center;
                  "
                >
                  <button
                    id="back"
                    class="btn btn-default px-4"
                    onClick="hideTabsCheckout('payment_methods');"
                  >
                    Back
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary checkout-btn"
                    :disabled="newAddressPending"
                    @click="checkout('credit_card')"
                  >
                    Checkout
                  </button>
                </div>
              </div>

              <div
                v-if="hasBank"
                id="tab_bank_acct"
                role="tabpanel"
                class="tab-pane"
                style="padding: 2rem; padding-bottom: 3rem"
              >
                <div class="sep-bottom-xs text-center">
                  <a :href="manageBankRoute">
                    <button class="btn btn-default btn-sm mt-2 checkout-btn">
                      New Bank Account
                    </button>
                  </a>
                </div>

                <div v-if="bankAccounts" class="form-group text-left">
                  <label for="bank_acct">Bank Account</label>
                  <select
                    id="bank_acct"
                    v-model="selectedBankAccountId"
                    name="bank_acct"
                    class="form-control"
                  >
                    <option
                      v-for="(bankAccount, index) in bankAccounts"
                      :key="index"
                      :value="bankAccount.id"
                    >
                      {{ bankAccount.nickname }}
                    </option>
                  </select>
                </div>

                <p class="sep-bottom-xs alert alert-info" style="margin: 20px">
                  <small>
                    {{ bankRetryPaymentTerms }}
                  </small>
                </p>
                <div
                  style="
                    display: grid;
                    grid-template-columns: auto auto;
                    justify-content: space-between;
                    align-items: center;
                  "
                >
                  <button
                    id="back"
                    class="btn btn-default px-4"
                    onClick="hideTabsCheckout('payment_methods');"
                  >
                    Back
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary checkout-btn"
                    :disabled="newAddressPending"
                    @click="checkout('bank_acct')"
                  >
                    Checkout
                  </button>
                </div>
              </div>

              <div
                v-if="hasWallet && walletCards"
                id="tab_wallet"
                role="tabpanel"
                class="tab-pane"
              >
                <div
                  id="wallet_container"
                  style="padding: 2rem; padding-bottom: 3rem"
                >
                  <div class="text-left form-group">
                    <label for="wallet">Wallet</label>
                    <select
                      id="wallet"
                      v-model="selectedWalletId"
                      name="wallet"
                      class="form-control"
                    >
                      <option
                        v-for="(walletCard, index) in walletCards"
                        :key="index"
                        :value="walletCard.id"
                      >
                        {{ walletCard.type ? walletCard.type : "Default" }}
                        {{ ` - ${walletCard.wallet.balance}` }}
                      </option>
                    </select>
                  </div>
                  <div
                    style="
                      display: grid;
                      grid-template-columns: auto auto;
                      justify-content: space-between;
                      align-items: center;
                    "
                  >
                    <button
                      id="back"
                      class="btn btn-default px-4"
                      onClick="hideTabsCheckout('payment_methods');"
                    >
                      Back
                    </button>
                    <button
                      class="btn btn-primary checkout-btn"
                      :disabled="newAddressPending"
                      @click="checkout('wallet')"
                    >
                      Checkout
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div
              id="new_credit_card_modal"
              class="modal fade"
              tabindex="-1"
              role="dialog"
              aria-labelledby="new_credit_card_modal"
            >
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <button
                      type="button"
                      class="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                    <h4 id="myModalLabel" class="modal-title">
                      New Credit Card
                    </h4>
                  </div>
                  <div class="modal-body">
                    <div
                      class="payment_instrument_logos text-center sep-bottom-xs col-sm-12"
                    >
                      <img alt="Visa" class="" src="/build/img/visa.png" />
                      <img alt="MasterCard" src="/build/img/mastercard.png" />
                      <img alt="Discover" src="/build/img/discover.png" />
                      <img
                        alt="American Express"
                        src="/build/img/american_express.png"
                      />
                      <img
                        alt="JCB"
                        src="/build/img/jcb.png"
                        style="margin-right: 0"
                      />
                    </div>
                    <div id="card-element"></div>
                    <div id="card-errors" role="alert"></div>
                  </div>
                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-default btn-sm"
                      data-dismiss="modal"
                    >
                      Close
                    </button>
                    <button
                      class="btn btn-primary btn-sm checkout-btn"
                      @click="submitNewCreditCard()"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="panel-footer text-center">
      <small class="checkout-terms">
        By placing this order, you agree to the
        <a href="/terms" title="Terms of Sale" target="_blank">
          terms of sale
        </a>
        and
        <a href="/privacy-policy" title="Privacy Policy" target="_blank">
          privacy policy
        </a>
        .
      </small>
    </div>
  </div>
</template>

<script>
import swal from "sweetalert2";

export default {
  props: {
    canCheckout: {
      type: Boolean,
      required: true,
    },
    hasBank: {
      type: Boolean,
      required: true,
    },
    manageBankRoute: {
      type: String,
      required: true,
    },
    hasWallet: {
      type: Boolean,
      required: true,
    },
    billingAddress: {
      type: Object,
      required: true,
    },
    shippingAddressId: {
      type: Number,
      required: true,
    },
    currency: {
      type: String,
      required: true,
    },
    createCustomerCardRoute: {
      type: String,
      required: true,
    },
    creditCards: {
      type: Array,
      required: true,
    },
    walletCards: {
      type: Array,
      required: true,
    },
    bankAccounts: {
      type: Array,
      required: true,
    },
    bankRetryPaymentTerms: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      internalCreditCards: this.creditCards,
      selectedCreditCardId: this.creditCards.length
        ? this.creditCards[0].id
        : null,
      selectedBankAccountId: this.bankAccounts.length
        ? this.bankAccounts[0].id
        : null,
      selectedWalletId: this.walletCards.length ? this.walletCards[0].id : null,
    };
  },

  computed: {
    newAddressPending() {
      return !this.billingAddress.id || !this.shippingAddressId;
    },
  },

  methods: {
    async submitNewCreditCard() {
      try {
        $("#new_credit_card_modal").modal("hide");
        await swal.fire({ title: "Validating Address...", padding: "2.5em" });
        swal.showLoading();
        swal.getTitle().textContent = "Creating Card...";
        const stripeSource = await this.createSourceCheckout();
        const card = await this.createCreditCard(stripeSource);
        swal.getTitle().textContent = "Processing...";
        this.internalCreditCards.push(card.data.card);
        this.selectedCreditCardId = card.data.card.id;
        swal.getTitle().textContent =
          "Credit Card created successfully! You may now use it to checkout!";
        swal.hideLoading();
      } catch (e) {
        $("#new_credit_card_modal").modal("show");
        swal.getTitle().textContent = e.message;
        swal.hideLoading();
      }
    },

    async createSourceCheckout() {
      // window.stripe and window.card are created by the card_element blade partial on the main checkout page
      return window.stripe
        .createSource(window.card, {
          type: "card",
          currency: this.currency,
          owner: {
            name: `${this.billingAddress.first_name} ${this.billingAddress.last_name}`,
            address: {
              line1: this.billingAddress.address,
              line2: this.billingAddress.address2,
              city: this.billingAddress.city,
              state: this.billingAddress.state,
              country: this.billingAddress.country,
              postal_code: this.billingAddress.zip,
            },
          },
          usage: "reusable",
        })
        .then((response) => {
          if (response.error) {
            throw new Error(`Stripe - ${response.error.message}`);
          }
          return {
            response: response.source,
            billing_id: this.billingAddress.id,
          };
        });
    },

    async createCreditCard(stripeSource) {
      const payload = {
        source_id: stripeSource.response.id,
        billing_id: stripeSource.billing_id,
      };

      return this.$http
        .post(this.createCustomerCardRoute, payload)
        .then((response) => response)
        .catch((e) => {
          throw new Error(`Credit Card - ${e.message}`);
        });
    },

    checkout(checkoutType) {
      // the terms checkboxes are in a slot, so we need to check the DOM directly
      if ($(".terms-box").length > $(".terms-box:checked").length) {
        swal.fire({
          title: "All terms must be accepted!",
          padding: "2.5em",
        });
        return;
      }

      let cardId;
      switch (checkoutType) {
        case "credit_card":
          cardId = this.selectedCreditCardId;
          break;
        case "bank_acct":
          cardId = this.selectedBankAccountId;
          break;
        case "wallet":
          cardId = this.selectedWalletId;
          break;
        default:
          cardId = null;
      }
      if (cardId === null) {
        swal.fire({
          title: "No Payment method was selected!",
          padding: "2.5em",
        });
        return;
      }

      const termsBoxes = $(".terms-box:checked")
        .toArray()
        .map((element) => element.value);

      // CheckoutForm will be responsible for loading state, building the form payload, and submitting
      this.$emit("checkout", {
        checkoutType,
        cardId,
        termsBoxes,
      });
    },
  },
};
</script>
